export const validFilmFormatIds = [1, 5]
export const EnglishLanguageId = 1

export const isFilmByFormatId = (formatId) => {
    return validFilmFormatIds.includes(formatId)
}

export const ExportFormat = {
    Excel: 'excel',
    Csv: 'csv'
}

// Contact Types
export const ContactTypeIds = {
    Member: 1,
    PotentialMember: 2,
    NonEligibleContributor: 3,
    Estate: 4,
    Company: 5,
    Invalid: 6,
    MultiUnknown: 7,
    NewWebMember: 8
}

// Membership Types - Group A (selectable) vs Group B (non-selectable)
export const MembershipTypeIds = {
    Ordinary: 1,      // Group A - Selectable
    Reciprocal: 2,    // Group A - Selectable
    Successor: 3,     // Group B - Non-selectable
    Associate: 4,     // Group B - Non-selectable
    Composite: 5,     // Group B - Non-selectable
    Payee: 6          // Group A - Selectable
}

// Selectable membership types (Group A)
export const SelectableMembershipTypeIds = [
    MembershipTypeIds.Ordinary,
    MembershipTypeIds.Reciprocal,
    MembershipTypeIds.Payee
]

// Utility function to check if a membership is selectable
export const isMembershipSelectable = (membershipTypeId) =>
    SelectableMembershipTypeIds.includes(membershipTypeId)

// Contribution Types
export const ContributionTypeIds = {
    Actor: 2,
    Director: 7
}

// Non-eligible contribution types that are always 0% (Actor, Director)
// These should be ignored when matching contribution scenarios
export const NonEligibleContributionTypeIds = [ContributionTypeIds.Actor, ContributionTypeIds.Director]

// Utility function to check if a contribution type is non-eligible by ID
export const isNonEligibleContributionType = (contributionType) =>
    NonEligibleContributionTypeIds.includes(contributionType?.id)

// Check if contact type is Non-Eligible Contributor
export const isNonEligibleContributor = (contactTypeId) =>
    contactTypeId === ContactTypeIds.NonEligibleContributor
